<template>
  <div class="repertContainer">
    <md-field>
      <md-input-item
        title="生产销售企业"
        v-model="form.enterpriseName"
        placeholder="請輸入生产销售企业"
        clearable
      />
      <md-input-item
        title="生产销售企业代码"
        v-model="form.enterpriseCode"
        placeholder="請输入生产销售企业代码"
        no-border
        maxlength="18"
        clearable
      />
      <md-button
        type="warning"
        :loading="loading"
        style="margin: 0.4rem 0"
        @click="submitpas"
      >保存</md-button
      >
    </md-field>

    <div class="declared_container" v-if="declarantList.length > 0">
      <div style="width: 95%">
        <p class="title">歷史申報人</p>
        <table border="0">
          <tr class="header">
            <th style="width: 2rem;text-align: left">生产销售企业</th>
            <th style="text-align: left">生产销售企业代码</th>
            <th>操作</th>
          </tr>
          <tr
            v-for="(item, index) in declarantList"
            :key="index"
            class="content"

          >
            <td  @click="addDeclarant(item)" style="text-align: left">{{ item.enterpriseName }}</td>
            <td  @click="addDeclarant(item)" style="text-align: left">{{ item.enterpriseCode }}</td>
            <td>
              <div style="display: flex;align-items: center;justify-content: center">
                <!--                <md-icon-->
                <!--                  name="success-color"-->
                <!--                  size="md"-->
                <!--                  svg-->
                <!--                  style="margin-right: 0.2rem"-->
                <!--                  @click="addDeclarant(item)"-->
                <!--                ></md-icon>-->
                <md-icon
                  name="clear"
                  color="gray"
                  size="md"
                  @click="deleteDeclarant(item, index)"
                ></md-icon>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Field,
  FieldItem,
  Button,
  InputItem,
  Toast,
  NoticeBar,
  Dialog
} from "mand-mobile";
import { isBlank } from "@/until/common.js";
import eventBus from "../../until/eventBus";

export default {
  components: {
    [Field.name]: Field,
    [Button.name]: Button,
    [FieldItem.name]: FieldItem,
    [InputItem.name]: InputItem,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog
  },
  name: "declarant",
  data() {
    return {
      form: {
        enterpriseCode: "",
        enterpriseName: "",
      },
      declarantList: [],
      loading: false
    };
  },
  mounted() {
    this.form.countryId = this.$route.query.countryId;
    this.getDeclareHistoryList();
  },
  methods: {
    getDeclareHistoryList() {
      this.http.APIASK(this.ports.getUserEnterpriseInfo, "post", {}).then(res => {
        this.declarantList = res;
      });
    },
    submitpas() {
      if (isBlank(this.form.enterpriseCode)) {
        Toast.failed("請輸入生产销售企业代码");
        return;
      }
      if (this.form.enterpriseCode.length!=18) {
        Toast.failed("請輸入18位生产销售企业代码");
        return;
      }
      if (isBlank(this.form.enterpriseName)) {
        Toast.failed("請輸入生产销售企业");
        return;
      }
      this.loading = true;
      this.addDeclarant({
        enterpriseCode: this.form.enterpriseCode,
        enterpriseName: this.form.enterpriseName,
      })

    },
    addDeclarant(data) {

      eventBus.$emit('setEnterprise', data);
      this.loading = false;
      this.$router.go(-1);

    },
    deleteDeclarant(record, index) {
      Dialog.confirm({
        content: "请确认是否删除该历史记录吗",
        confirmText: "确定",
        onConfirm: () => {
          this.http
            .APIASK(this.ports.delUserEnterpriseInfo, "post", { id: record.id })
            .then(res => {
              this.declarantList.splice(index, 1);
            });
        }
      });
    }
  }
};
</script>

<style lang="less">
.repertContainer {
  .md-field-item-content:before {
    content: "";
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }
  .md-field {
    padding: 0 0.4rem;
  }
  .md-field-item-title {
    text-align: left;
    width: 2.7rem !important;
  }
  .tip {
    margin: 0.4rem 0;
  }

  .declared_container {
    background: white;
    padding: 0.2rem;
    flex-direction: column;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    margin-top: 0.5rem;
    table {
      width: 100%;
      .header {
        color: #888888;
        line-height: 0.4rem;
        th:first-child {
          width: 15%;
        }
        th:last-child {
          width: 10%;
        }
      }
      .content {
        line-height: 0.6rem;
      }
    }
    .title {
      font-size: 0.26rem;
      text-align: left;
      font-weight: bold;
      margin: 0.2em 0 0.5em 0;
    }
  }
}
</style>
